var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Card, Col, Row } from 'antd';
import ReactEcharts from 'echarts-for-react';
import * as React from 'react';
import observer from 'src/shared/decorators/observer';
import services from 'src/shared/services/services';
import './dashboard.css';
var Dashboard = /** @class */ (function (_super) {
    __extends(Dashboard, _super);
    function Dashboard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.options = {};
        return _this;
    }
    Dashboard.prototype.componentDidMount = function () {
        var _this = this;
        services.Report.dashboard().then(function (result) {
            _this.options = result;
        });
    };
    Dashboard.prototype.render = function () {
        return (React.createElement("div", { style: { padding: '20px' } },
            React.createElement(Row, { gutter: 16 },
                React.createElement(Col, { md: 4 },
                    React.createElement("div", { className: "vertex-card bg-success-400" },
                        React.createElement("div", { className: "media" },
                            React.createElement("div", { className: "media-body" },
                                React.createElement("h3", null, this.options.girisiDevamEdenBS),
                                React.createElement("span", { className: "text-uppercase font-size-xs" }, "Giri\u015Fi Devam Eden Ba\u015Fvuru Say\u0131s\u0131")),
                            React.createElement("div", { className: "icon" },
                                React.createElement("i", { className: "icon-pencil7" }))))),
                React.createElement(Col, { md: 4 },
                    React.createElement("div", { className: "vertex-card bg-danger-400" },
                        React.createElement("div", { className: "media" },
                            React.createElement("div", { className: "media-body" },
                                React.createElement("h3", null, this.options.onayBekleyenBS),
                                React.createElement("span", { className: "text-uppercase font-size-xs" }, "Onay Bekleyen Ba\u015Fvuru Say\u0131s\u0131")),
                            React.createElement("div", { className: "icon" },
                                React.createElement("i", { className: "icon-checkmark4" }))))),
                React.createElement(Col, { md: 6 },
                    React.createElement("div", { className: "vertex-card bg-warning-400" },
                        React.createElement("div", { className: "media" },
                            React.createElement("div", { className: "media-body" },
                                React.createElement("h3", null, this.options.degerlendirilmeyeGonderilmeyenBS),
                                React.createElement("span", { className: "text-uppercase font-size-xs" }, "De\u011Ferlendirilmeye G\u00F6nderilmeyen Ba\u015Fvuru Say\u0131s\u0131")),
                            React.createElement("div", { className: "icon" },
                                React.createElement("i", { className: "icon-paperplane" }))))),
                React.createElement(Col, { md: 5 },
                    React.createElement("div", { className: "vertex-card bg-primary-400" },
                        React.createElement("div", { className: "media" },
                            React.createElement("div", { className: "media-body" },
                                React.createElement("h3", null, this.options.degerlendirmeBekleyenBS),
                                React.createElement("span", { className: "text-uppercase font-size-xs" }, "De\u011Ferlendirme Bekleyen Ba\u015Fvuru Say\u0131s\u0131")),
                            React.createElement("div", { className: "icon" },
                                React.createElement("i", { className: "icon-stack2" }))))),
                React.createElement(Col, { md: 5 },
                    React.createElement("div", { className: "vertex-card bg-indigo-400" },
                        React.createElement("div", { className: "media" },
                            React.createElement("div", { className: "media-body" },
                                React.createElement("h3", null, this.options.degerlendirilenBS),
                                React.createElement("span", { className: "text-uppercase font-size-xs" }, "De\u011Ferlendirilen Ba\u015Fvuru Say\u0131s\u0131")),
                            React.createElement("div", { className: "icon" },
                                React.createElement("i", { className: "icon-stack" })))))),
            this.options && this.options.sehirRaporu && (React.createElement("div", null,
                React.createElement(Row, { gutter: 16 },
                    React.createElement(Col, { md: 12 },
                        React.createElement(Card, null,
                            React.createElement(ReactEcharts, { option: this.options.sehirRaporu }))),
                    React.createElement(Col, { md: 12 },
                        React.createElement(Card, null,
                            React.createElement(ReactEcharts, { option: this.options.yatirimCinsiRaporu })))),
                React.createElement(Row, { gutter: 16, style: { marginTop: '20px' } },
                    React.createElement(Col, { md: 24 },
                        React.createElement(Card, null,
                            React.createElement(ReactEcharts, { style: { height: '700px' }, option: this.options.sektorRaporu })))),
                ' '))));
    };
    Dashboard = __decorate([
        observer
    ], Dashboard);
    return Dashboard;
}(React.Component));
export default Dashboard;



//////////////////
// WEBPACK FOOTER
// ./src/app/core/Dashboard.tsx
// module id = 1292
// module chunks = 0